// VIDEO BOX
document.addEventListener("DOMContentLoaded", function () {
    const allBoxes = document.querySelectorAll(".videoBoxAll");

    allBoxes.forEach((box) => {
        const video = box.querySelector("video");
        const playBtn = box.querySelector(".videoBoxPlayBtn");

        video.controls = false;

        playBtn.addEventListener("click", () => {
            playVideo(video, box);
        });

        video.addEventListener("click", () => {
            if (video.paused) {
                playVideo(video, box);
            } else {
                pauseVideo(video, box);
            }
        });

        function playVideo(currentVideo, currentBox) {
            allBoxes.forEach((otherBox) => {
                const otherVideo = otherBox.querySelector("video");
                if (otherVideo !== currentVideo) {
                    otherVideo.pause();
                    otherVideo.controls = false;
                    otherBox.classList.remove("playing");
                }
            });

            currentVideo.play();
            currentVideo.controls = true;
            currentBox.classList.add("playing");
        }

        function pauseVideo(currentVideo, currentBox) {
            currentVideo.pause();
            currentVideo.controls = false;
            currentBox.classList.remove("playing");
        }

        video.addEventListener("pause", () => {
            video.controls = false;
            box.classList.remove("playing");
        });

        video.addEventListener("ended", () => {
            video.controls = false;
            box.classList.remove("playing");
        });
    });
});
// VIDEO BOX



// PRODUCT TABS 
function productTabs(evt, tabName) {
    var i, tabcontent, tablinks;
    tabcontent = document.getElementsByClassName("DescriptionAndReviews_tabcontent");
    for (i = 0; i < tabcontent.length; i++) {
        tabcontent[i].style.display = "none";
    }
    tablinks = document.getElementsByClassName("DescriptionAndReviews_tablinks");
    for (i = 0; i < tablinks.length; i++) {
        tablinks[i].className = tablinks[i].className.replace(" active", "");
    }
    document.getElementById(tabName).style.display = "block";
    evt.currentTarget.className += " active";
}

document.addEventListener("DOMContentLoaded", function () {
    var defaultTab = document.getElementById("defaultOpen");
    if (defaultTab) {
        defaultTab.click();
    }
});
// PRODUCT TABS

document.addEventListener("DOMContentLoaded", () => {
  const counters = document.querySelectorAll(".ourStats-box-inn h3");
  if (!counters.length) return;

  const duration = 2000;

  const animate = (el) => {
    const rawText = el.textContent.trim();
    const match = rawText.match(/^([^\d]*)([\d,]+\.?\d*)(.*)$/);
    if (!match) return;

    const [, prefix, numStr, suffix] = match;
    const target = parseFloat(numStr.replace(/,/g, ""));
    const isDecimal = numStr.includes(".");
    const decimals = isDecimal ? numStr.split(".")[1].length : 0;
    const hasCommas = numStr.includes(",");

    let start = null;

    const step = (timestamp) => {
      if (!start) start = timestamp;
      const progress = Math.min((timestamp - start) / duration, 1);
      const eased = 1 - (1 - progress) * (1 - progress);
      const current = eased * target;
      
      let val = isDecimal ? current.toFixed(decimals) : Math.floor(current);
      if (hasCommas) val = Number(val).toLocaleString();

      el.textContent = prefix + val + suffix;

      if (progress < 1) {
        requestAnimationFrame(step);
      } else {
        el.textContent = rawText;
      }
    };
    requestAnimationFrame(step);
  };

  if ("IntersectionObserver" in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          animate(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.5 });
    counters.forEach((c) => observer.observe(c));
  } else {
    counters.forEach(animate);
  }
});

{
document.addEventListener("DOMContentLoaded", () => {
  const header = document.querySelector("#header-component");
  if (!header) return;
  let ticking = false;
  function updateMenuStyle() {
    const target = window.innerWidth <= 1100 ? "drawer" : "menu";
    const current = header.getAttribute("data-menu-style");
    if (current !== target) {
      header.setAttribute("data-menu-style", target);
    }
    ticking = false;
  }
  updateMenuStyle();
  window.addEventListener("resize", updateMenuStyle, { passive: true });
  const observer = new MutationObserver(() => {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(updateMenuStyle);
    }
  });
  observer.observe(header, {
    attributes: true,
    attributeFilter: ["data-menu-style"]
  });
});
}